export const NOTIFICATIONS = 'Notifications' as const;
